export type State = {
  loghi?: Record<string, string>;
};

export const initialState: State = {
  loghi: undefined,
};
